import { render, staticRenderFns } from "./ManageUserRoleModal.vue?vue&type=template&id=1482a763&"
import script from "./ManageUserRoleModal.vue?vue&type=script&lang=js&"
export * from "./ManageUserRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports